<template>
  <div class="tariffselect" :class="{simple: disableProviderSelect}">
    <SimonModal :is-visible="showUnportableInfoModal" @hide="deselectUnportableProvider()" id="unportable-info-modal">
      <slot name="txtUnportableInfoModal"></slot>
    </SimonModal>
    <form>
      <LabeledCustomSwitch name="switchMnpIn" :value.sync="active">
        <template #lbl><slot name="lblMnpSwitch"></slot></template>
      </LabeledCustomSwitch>
    </form>
    <div v-if="active && !disableProviderSelect">
      <div aria-live="polite"  class="tariffselect--label">
        <slot name="txtMnpSwitch"></slot>
      </div>
      <div class="tariffselect--select">
        <b-form
          v-on:submit.prevent.stop
          :id="'form' + _uid"
          :novalidate="true"
          class="tariff-select"
          tariff-select
          ref="form">
          <CheckoutMnpInProviderSelect ref="providerSelect"
            :key="1"
            :withNetworkSelect="false"
            :active.sync="active"
            :brandName.sync="provider.brandName"
            :network.sync="provider.network"
            :providerKey.sync="provider.key"
            :providerCode.sync="provider.code"
            :providerNetwork.sync="provider.network"
            :relatedTariff.sync="provider.relatedTariff"
            :unportableFound.sync="isUnportable"
            :unportableSelected.sync="showUnportableInfoModal"
            :embedded="true"
            :quick-selection-brand="quickSelectionBrand"
            @mnpin-provider-determined="storeSelectedProvider"
            :show-error-box-below="false"
            :process="process"
          >
            <template #txtPlaceholderSearchField>
              <slot name="txtPlaceholderSearchField"></slot>
            </template>

            <template #txtSearchFieldAltText>
              <slot name="txtSearchFieldAltText"></slot>
            </template>

            <template #buttonClearProviderAltText>
              <slot name="buttonClearProviderAltText"></slot>
            </template>

            <template v-for="slot in possibleChildSlotsFor('ProviderSelect')" v-slot:[`${slot.child}`]>
              <slot :name="`${slot.parent}`"></slot>
            </template>
          </CheckoutMnpInProviderSelect>
        </b-form>
      </div>
    </div>
    <div v-else-if="!disableProviderSelect">
      <div aria-live="polite"  class="tariffselect--label">
        <slot name="txtNoMnpSwitch"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { BForm } from 'bootstrap-vue'
import preFilledInput from '@/mixins/preFilledInput'
import preFilledObjectInput from '@/mixins/preFilledObjectInput'
import CheckoutMnpInProviderSelect from '@/components/process/generic/Tariff/MnpIn/ProviderSelect.vue'
import SimonModal from '@/components/modal/SimonModal.vue'
import LabeledCustomSwitch from '@/components/forms/LabeledCustomSwitch.vue'

export default {
  name: 'Tariffselect',
  data () {
    return {
      loading: false,
      isUnportable: false,
      showUnportableInfoModal: false
    }
  },
  mixins: [
    preFilledInput('active', 'storedMNPActive'),
    preFilledObjectInput('provider', 'storedMNPProvider')
  ],
  components: {
    SimonModal,
    CheckoutMnpInProviderSelect,
    BForm,
    LabeledCustomSwitch
  },
  mounted () {
    this.initialize()
  },
  watch: {
    active: function (v) {
      this.setMnpActive(v)
      if (!v) { // legacy
        this.setSelectedTariff(this.defaultTariff)
      } else {
        this.storeSelectedProvider()
      }
      this.$store.commit('checkoutv2/' + this.process + '/_mnpData/setActive', v)
    }
  },
  methods: {
    ...mapActions('checkout/mnpData', [
      'getProviderList'
    ]),
    ...mapActions('checkout/tariff', ['setSelectedTariff']), // legacy
    async initialize () {
      await this.getProviderList()
      if (this.$refs.providerSelect) {
        this.$refs.providerSelect.tryToDetermineProvider()
      }
    },
    setMnpActive (active) {
      this.$store.commit('checkoutv2/' + this.process + '/_mnpData/setActive', active)
    },
    setProvider (provider) {
      this.$store.commit('checkoutv2/' + this.process + '/_mnpData/setProvider', provider)
    },
    getProviderList () {
      this.$store.dispatch('checkoutv2/' + this.process + '/_mnpData/getProviderList')
    },
    storeSelectedProvider () {
      this.setSelectedTariff(this.provider.relatedTariff) // legacy
      this.setProvider(this.provider)
    },
    deselectUnportableProvider () {
      this.showUnportableInfoModal = false
      this.$refs.providerSelect.resetProviderSelection()
      this.$refs.providerSelect.resetInputField()
    }
  },
  computed: {
    ...mapGetters('checkout/tariff', [
      'defaultTariff'
    ]),
    storedMNPActive () {
      return this.$store.getters['checkoutv2/' + this.process + '/_mnpData/active']
    },
    storedMNPProvider () {
      return this.$store.getters['checkoutv2/' + this.process + '/_mnpData/provider']
    },
    mnpData: function () {
      return {
        active: this.storedMNPActive,
        provider: this.storedMNPProvider
      }
    }
  },
  props: {
    quickSelectionBrand: {
      type: String,
      default: ''
    },
    process: {
      type: String,
      default: 'ordering'
    },
    disableProviderSelect: {
      type: Boolean,
      default: false
    }
  }
}
</script>
